import React from "react";
import {
    Typography,
    FormControl,
    Select,
    MenuItem,
    IconButton,
    Box,
    useMediaQuery,
    useTheme,
    Tooltip
} from "@mui/material";

const DateFrequencySelector = ({
    handleNumberSelectorChange,
    handleDayButtonClick,
    selectedDays,
    selectedNumber,
    disabled
}) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: true
    });
    const days = [
        { id: 1, title: "M" },
        { id: 2, title: "T" },
        { id: 3, title: "W" },
        { id: 4, title: "T" },
        { id: 5, title: "F" },
        { id: 6, title: "S" },
        { id: 0, title: "S" }
    ];

    const daysStyleFunction = (val) => {
        return {
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: val ? "primary.main" : "white",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: val && !disabled ? "primary.main" : "rgb(0,0,0,0.23)",
            minWidth: 0,
            color: val ? "white" : "primary.main",
            "&:hover": {
                backgroundColor: "primary.main",
                borderColor: "primary.main",
                color: "white"
            },
            "&:active": {
                backgroundColor: "primary.main",
                borderColor: "primary.main",
                color: "white"
            },
            "@media (hover: none)": {
                "&:hover": {
                    backgroundColor: val ? "primary.main" : "white",
                    borderColor:
                        val && !disabled ? "primary.main" : "rgb(0,0,0,0.23)",
                    color: val ? "white" : "primary.main"
                }
            }
        };
    };

    return (
        <>
            <Tooltip
                componentsProps={{
                    tooltip: {
                        sx: {
                            width: "234px"
                        }
                    }
                }}
                disableInteractive
                title={
                    disabled &&
                    "To add repeating blocked time, set a date range of more than one day"
                }
            >
                <Box
                    sx={{
                        display: "block",
                        width: "100%",
                        [theme.breakpoints.up("md")]: {
                            display: "flex",
                            justifyContent: "space-between"
                        }
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: isDesktop ? "9px" : "18px"
                        }}
                    >
                        <Typography variant={disabled && "disabled"}>
                            Repeat every
                        </Typography>
                        <FormControl>
                            <Select
                                id="week-frequency"
                                name="week-frequency"
                                value={selectedNumber}
                                onChange={handleNumberSelectorChange}
                                disabled={disabled}
                                sx={{
                                    width: "58px",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "0px !important"
                                    }
                                }}
                            >
                                {Array.from({ length: 9 }, (_, i) => (
                                    <MenuItem key={i + 1} value={i + 1}>
                                        {i + 1}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Typography
                            variant={disabled && "disabled"}
                        >{`${selectedNumber > 1 ? "weeks" : "week"} on`}</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            gap: "6px",
                            width: !isDesktop ? "100%" : "auto",
                            justifyContent: !isDesktop && "space-between",
                            marginTop: !isDesktop && "18px"
                        }}
                    >
                        {days.map((day) => (
                            <IconButton
                                key={day.id}
                                onClick={() => handleDayButtonClick(day.id)}
                                sx={daysStyleFunction(
                                    selectedDays.includes(day.id)
                                )}
                                disabled={disabled}
                            >
                                <Box
                                    sx={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        fontFamily: "roboto"
                                    }}
                                >
                                    {day.title}
                                </Box>
                            </IconButton>
                        ))}
                    </Box>
                </Box>
            </Tooltip>
        </>
    );
};

export default DateFrequencySelector;
